export default {
  computed: {
    /**
     * Get the shipment fee.
     *
     * @returns {number}
     */
    fee() {
      return this.calculateExtraFee(
        this.calculateDestinationFee(
          this.calculateFreeShipping(
            this.calculateStoreFee(
              this.calculateFee()
            )
          )
        )
      );
    },


    /**
     * Get the balance needed for free shipping.
     *
     * @returns {number}
     */
    balance() {
      return this.shipment.threshold - this.subtotal;
    },
  },

  methods: {

    /**
     * Calculate extra fee.
     *
     * @param {number} fee
     * @returns {number}
     */
    calculateExtraFee(fee) {
      return fee
        + (this.shipment.shipOnSaturday ? 2.5 : 0)
        + (this.shipment.sameDayDelivery ? 5.0 : 0);
    },

    /**
     * Calculate the destination fee.
     *
     * @param {number} fee
     * @returns {number}
     */
    calculateDestinationFee(fee) {
      return this.shipment.destination === 'store' ? 0 : fee;
    },

    /**
     * Calculate the free shipping.
     *
     * @param {number} fee
     * @returns {number}
     */
    calculateFreeShipping(fee) {
      return this.isFree() ? 0 : fee;
    },

    /**
     * Check if the shipment is free.
     *
     * @returns {boolean}
     */
    isFree() {
      return this.subtotal >= this.shipment.threshold;
    },

    /**
     * Calculate the store fee.
     *
     * @param {number} fee
     * @returns {number}
     */
    calculateStoreFee(fee) {
      return this.store.fee[this.shipment.method.id] || fee;
    },

    /**
     * Get the shipment method fee.
     *
     * @returns {number}
     */
    calculateFee() {
      return this.shipment.method.fee;
    },
  },
};
